import { StyleSheet } from 'aphrodite';

import { AssetsItems } from '../AssetsItems';

export class AssetsListPartner extends AssetsItems {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/partners/AssetsListPartner.js